module.exports = __webpack_public_path__ + "assets/checkbox-hover.55421d5b.svg";